import React from 'react';
import SelectField from './../Form/SelectField';

const FormP22T3 = React.memo((props) => {
    let clinicOptions = [{ value: '', label: 'Select option' }];
    for (let i = 0; i < props.clinics.length; i++) {
        clinicOptions.push({ value: props.clinics[i].id, label: props.clinics[i].name });
    }

    let selectedLocation = 'Select a Clinic';
    for (let i = 0; i < props.clinicLocations.length; i++) {
        if (parseInt(props.locationId) === parseInt(props.clinicLocations[i].id)) {
            selectedLocation = props.clinicLocations[i].name;
            break;
        }
    }

    if (props.fetchingClinicLocations) {
        selectedLocation = <div className="loading-locations"><i className="fas fa-circle-notch fa-spin" /></div>;
    }

    const handleChangeClinic = (value) => {
        props.setLocationId('');
        props.fetchClinicLocations(value);
        props.setClinicId(value);
        props.setQuantity('');

        props.checkAvailableItems(value, 'p22t3', props.language);
    }

    let quantityOptions = [{ value: '', label: 'Select option' }];
    for (let i = 1; i <= 10; i++) {
        quantityOptions.push({ value: i, label: i });
    }

    return (
        <form action="" className="p22-container">
            <hr />
            <h5 className="description-header">Shipping Information</h5>
            <SelectField
                required
                label="Clinic Name"
                value={props.clinicId}
                setFunction={handleChangeClinic}
                options={clinicOptions}
            />
            <div class="variable">
                <div class="label">Your Location:</div>
                <div className="location-address">{selectedLocation}</div>
            </div>
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={quantityOptions}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> No Recording Notice Vinyl Wall Cling</div>
                <div className="mt-2">
                    <span className="label">Description:</span>
                    <div>
                        This bilingual (English and Spanish) vinyl cling notifies patients that photography, videography, or audio recording 
                        is not permitted without consent. The poster can be displayed in exam rooms, specifically on the back of exam room 
                        doors or on cabinet doors.
                    </div>
                </div>
                <div className="description-list">
                    <span className="label">Details:</span>
                    <ul>
                        <li>8.5x11"</li>
                        <li>Full Color</li>
                        <li>Adhesive Vinyl - Peel and stick to a flat and clean surface</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP22T3;
